export default __webpack_public_path__ + "static/media/EthosLife_grey.cddabcfd.svg";